import React, { useState, useCallback } from 'react';
import { SmileOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import EmojiPalette from '../../../EmojiPalette';
import { createPortal } from 'react-dom';
import useCheckIfMobile from '../../../../../helpers/hooks/useCheckIfMobile';
import styles from './SendMessageReaction.module.scss';
const PICKER_WIDTH = 352;
const PICKER_HEIGHT = 435;
const VIEWPORT_PADDING = 12;
const SendMessageReaction = ({ onSendMessageReaction, incoming }) => {
    const [reactionMenuOpen, setReactionMenuOpen] = useState(false);
    const [portalStyle, setPortalStyle] = useState({});
    const isMobile = useCheckIfMobile();
    const onEmojiSelectHandle = (emoji) => {
        onSendMessageReaction(emoji.native);
        setReactionMenuOpen(false);
    };
    // Calculate the position of the emoji picker based on the button position that called it
    // always place full picker on the screen
    const calculatePosition = useCallback((buttonRect) => {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const style = {};
        const spaceAbove = buttonRect.top;
        const spaceBelow = viewportHeight - buttonRect.bottom;
        if (spaceAbove >= PICKER_HEIGHT + VIEWPORT_PADDING) {
            style.bottom = viewportHeight - buttonRect.top + VIEWPORT_PADDING;
        }
        else if (spaceBelow >= PICKER_HEIGHT + VIEWPORT_PADDING) {
            style.top = buttonRect.bottom + VIEWPORT_PADDING;
        }
        else {
            if (spaceAbove > spaceBelow) {
                style.top = VIEWPORT_PADDING;
            }
            else {
                style.bottom = VIEWPORT_PADDING;
            }
        }
        let left = buttonRect.left;
        if (incoming) {
            left = buttonRect.right - PICKER_WIDTH;
        }
        if (left + PICKER_WIDTH > viewportWidth - VIEWPORT_PADDING) {
            left = viewportWidth - PICKER_WIDTH - VIEWPORT_PADDING;
        }
        if (left < VIEWPORT_PADDING) {
            left = VIEWPORT_PADDING;
        }
        style.left = left;
        return style;
    }, [incoming]);
    const onMenuOpen = (e) => {
        e.stopPropagation();
        if (!isMobile) {
            const buttonRect = e.currentTarget.getBoundingClientRect();
            setPortalStyle(calculatePosition(buttonRect));
        }
        setReactionMenuOpen(!reactionMenuOpen);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(styles.addReactionContainer, styles.animateIn, 'send-reaction-container', {
                [styles.incoming]: incoming,
            }), onClick: onMenuOpen },
            React.createElement("div", { className: styles.addReactionButton },
                React.createElement(SmileOutlined, null))),
        reactionMenuOpen &&
            createPortal(React.createElement("div", { className: styles.portalContainer, style: isMobile
                    ? {
                        bottom: VIEWPORT_PADDING,
                        left: VIEWPORT_PADDING,
                        right: VIEWPORT_PADDING,
                    }
                    : portalStyle },
                React.createElement(EmojiPalette, Object.assign({ className: isMobile ? styles.emojiPaletteMobile : styles.emojiPaletteReset, onClickOutside: () => setReactionMenuOpen(false), onEmojiSelectHandle: onEmojiSelectHandle }, (isMobile && {
                    // picker is too large for small screens, reduce size
                    perLine: 7,
                    emojiSize: 18,
                    emojiButtonSize: 28,
                    previewPosition: 'none',
                })))), document.body)));
};
export default SendMessageReaction;
